import { IonButton, IonIcon } from '@ionic/react';
import { addCircleOutline } from 'ionicons/icons';
import { AddPhotoTile } from './AddPhotoTile';
import { PostPhotoThumb } from './PostPhotoThumb';
import type { EditorPhoto } from './types';

interface PostPhotoStripProps {
  photos: EditorPhoto[];
  maxPhotos: number;
  disabled?: boolean;
  onAdd: () => void;
  /** Receives the `key` of the photo to remove. */
  onDelete: (key: string) => void;
}

/**
 * Row of the post's photos in the editor, scrolling sideways when needed, followed
 * by the "+" tile while the post has room for more photos. A post without photos
 * only shows an "Añadir fotos" action (like "Añadir enlace relacionado"), so it
 * doesn't compete with the editor; the row appears with the first photo.
 */
export const PostPhotoStrip = ({
  photos,
  maxPhotos,
  disabled = false,
  onAdd,
  onDelete,
}: PostPhotoStripProps) =>
  photos.length === 0 ? (
    <IonButton
      fill="clear"
      size="small"
      className="self-start"
      // No start padding so the icon lines up with the editor's left edge.
      style={{ '--padding-start': '0px' }}
      onClick={onAdd}
      disabled={disabled}
    >
      {/* Inline margin: Tailwind's base reset zeroes Ionic's slotted-icon gap. */}
      <IonIcon icon={addCircleOutline} slot="start" aria-hidden="true" style={{ marginInlineEnd: '6px' }} />
      Añadir fotos
    </IonButton>
  ) : (
    <div className="flex gap-2 overflow-x-auto pb-1" data-testid="post-photo-strip">
      {photos.map((photo) => (
        <PostPhotoThumb key={photo.key} url={photo.url} onDelete={() => onDelete(photo.key)} />
      ))}
      {photos.length < maxPhotos && <AddPhotoTile onClick={onAdd} disabled={disabled} />}
    </div>
  );
